export interface NewsWidget {
    collection: "previews" | "posts";
    item: Record<string, any>;
}
